import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../Components/Other/breadcrumbs";
import { ReactComponent as TowerIcon } from "../../Global Icons/towers.svg";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  getProjectData,
  viewProjectCatalogue,
  updateBookingStatus,
} from "../../Redux/Actions/projectActions";
import TextInput from "../../Global Functions/textInput";
import axios from "axios";
import UnitDetailsModal from "../../Global Functions/catalogueModal";
import "./viewProjectsCatelogue.css";

const ViewCatalogue = () => {
  const { id } = useParams();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();

  const [towerID, setTowerID] = useState("");
  const [towerData, setTowerData] = useState();
  const [unitData, setUnitData] = useState();

  // 🔘 Toggle State for booking availability
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    dispatch(getProjectData(id));
  }, [id, dispatch]);

  const { project, project_catalogue } = useSelector((state) => state.projects);

  useEffect(() => {
    const catalogueData = {
      project_id: id,
      category: project?.data?.categories[0]?._id,
    };
    dispatch(viewProjectCatalogue(catalogueData));
  }, [project?.data?.categories, id, dispatch]);

  useEffect(() => {
    if (towerID) {
      const matchedData = project_catalogue?.data?.data?.find(
        (item) => item._id === towerID
      );
      setTowerData(matchedData);
      // Set toggle state to current is_booking_available from this tower
      if (matchedData?.is_booking_available !== undefined) {
        setToggle(matchedData.is_booking_available);
      }
    }
  }, [towerID, project_catalogue]);

  useEffect(() => {
    if (project_catalogue?.data) {
      setTowerID(project_catalogue?.data[0]?._id);
    }
  }, [project_catalogue?.data]);

  useEffect(() => {
    if (unitData) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [unitData]);

  const unitsAvailable = project_catalogue?.data?.statusCounts
    ? project_catalogue.data.statusCounts.total -
      project_catalogue.data.statusCounts.sold
    : "";

  const statusChangeHandler = async () => {
    const statusPayload = {
      project_id: id,
      status: "sold",
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (!unitsAvailable) {
      await axios.post(`${BASE_URL}/project/change-status`, statusPayload, config);
      return toast.success("Status Changed Successfully!!");
    } else {
      return toast.error("Project must be sold out!!");
    }
  };

  const toggleBookingStatus = async () => {
    if (!towerID) return;

    try {
      const payload = {
        catalogue_id: towerID,
        is_booking_available: !toggle,
      };
      await dispatch(updateBookingStatus(payload));
      setToggle((prev) => !prev);
    } catch (error) {
      // Optionally handle error here
    }
  };

  useEffect(() => {
    console.log("Project catalogue data:", project_catalogue);
  }, [project_catalogue]);

  return (
    <div className="catalogue-view-page-wrapper">
      {/* ================================== */}

      <div className="catalogue-view-page-header flex-container flex-align-center">
        <BreadCrumbs title="Project Details" route1="/projects" />
        <div
          style={{ gap: "10px" }}
          className="catalogue-view-page-header-right gap-10 flex-container flex-align-center"
        >
          {Array.isArray(project_catalogue?.data?.data)
            ? project_catalogue.data.data.map((item, index) => {
                return (
                  <button
                    key={item._id}
                    className={`flex-container flex-align-center ${
                      towerID === item._id ? "active-catalogue" : ""
                    }`}
                    id={`tower-btn-${index}`}
                    onClick={() => {
                      setTowerID(item._id);
                    }}
                  >
                    <TowerIcon />
                    <span>{item.tower_name}</span>
                  </button>
                );
              })
            : []}
        </div>
        <div className="project_catalogue_stats">
          <h3>Project Stats</h3>
          <TextInput
            label="Total"
            disabled={true}
            value={
              project_catalogue?.data?.statusCounts
                ? project_catalogue.data.statusCounts.total
                : ""
            }
          ></TextInput>
          <TextInput
            label="Sold"
            disabled={true}
            value={
              project_catalogue?.data?.statusCounts
                ? project_catalogue.data.statusCounts.sold
                : ""
            }
          ></TextInput>
          <TextInput label="Available" disabled={true} value={unitsAvailable}></TextInput>

          {unitsAvailable ? (
            <></>
          ) : (
            <button onClick={statusChangeHandler} className="button-class-white">
              Sold
            </button>
          )}
        </div>
      </div>

      {/* ================================== */}
      {/* 🔘 TOGGLE BUTTON — render only if tower selected */}
      {towerID && (
        <div className="catalogue-toggle-top flex-container flex-align-center">
          <button
            onClick={toggleBookingStatus}
            className={`toggle-btn ${toggle ? "active" : ""}`}
          >
            {toggle ? "Booking Available" : "Booking Un-Available"}
          </button>
        </div>
      )}

      {towerData && (
        <div className="catalogue-view-container flex-container">
          <div className="catalogue-view-floors gap-10 flex-container flex-align-center">
            {towerData?.catalogue?.map((item, idx) => {
              return (
                <div key={idx} className="catalogue-floor-tile mirror">
                  <span>{item.floor === 0 ? "G" : item.floor}</span>
                </div>
              );
            })}
          </div>
          <div className="mirror catalogue-map-container flex-container">
            {towerData?.catalogue?.map((item, index) => {
              return (
                <div key={index} className="catalogue-map-tile grid-container gap-15">
                  {Object.entries(item)
                    .filter(([key]) => !isNaN(key))
                    .map(([_, unit]) => (
                      <div
                        key={unit.unitno}
                        className="mirror catalogue-unit-tile-main gap-15 flex-container flex-align-center"
                        onClick={() => setUnitData(unit)}
                      >
                        <div
                          className="catalogue-tile-unit-no mirror flex-container flex-center"
                          style={
                            unit.status === "unavl"
                              ? { border: "2px solid rgb(230, 73, 0)" }
                              : unit.status === "avl"
                              ? { border: "2px solid rgb(8, 166, 0)" }
                              : unit.status === "onhold"
                              ? { border: "2px solid rgb(198, 205, 0)" }
                              : unit.status === "sold"
                              ? { border: "2px solid rgb(189, 0, 0)" }
                              : {}
                          }
                        >
                          <span> {unit.unitno} </span>
                        </div>
                        <div className="catalogue-tile-unit-type">
                          <span>{unit.unit}</span>
                        </div>
                      </div>
                    ))}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {unitData && <UnitDetailsModal unit={unitData} onClose={() => setUnitData(null)} />}
    </div>
  );
};

export default ViewCatalogue;
